import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AppShell, Burger, Group, Container } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { AdminNavbar } from './AdminNavbar';
import { IconBell, IconSearch } from '@tabler/icons-react';

export const AdminLayout: React.FC = () => {
  const [mobileOpened, { toggle: toggleMobile }] = useDisclosure();
  const [desktopOpened, { toggle: toggleDesktop }] = useDisclosure(true);
  const location = useLocation();

  const getPageTitle = () => {
    const path = location.pathname;
    if (path.includes('/admin/dashboard')) return 'Dashboard';
    if (path.includes('/admin/theme')) return 'Theme management';
    if (path.includes('/admin/users')) return 'User Management';
    if (path.includes('/admin/profile')) return 'My Profile';
    if (path.includes('/admin/security')) return 'Security Settings';
    if (path.includes('/admin/gallery')) return 'Gallery Management';
    if (path.includes('/admin/settings/general')) return 'General Settings';
    if (path.includes('/admin/settings/company')) return 'Company Information';
    if (path.includes('/admin/settings/social')) return 'Social Media Settings';
    if (path.includes('/admin/settings/seo')) return 'SEO Settings';
    if (path.includes('/admin/settings/email')) return 'Email Settings';
    return 'Admin Dashboard';
  };

  return (
    <AppShell
      header={{ height: 60 }}
      navbar={{
        width: 300,
        breakpoint: 'md',
        collapsed: { mobile: !mobileOpened, desktop: !desktopOpened },
      }}
      padding="md"
    >
      {/* Header */}
      <AppShell.Header
        style={{
          background: 'var(--primary-color)',
          color: '#fff',
          borderBottom: '1px solid rgba(255,255,255,0.1)',
        }}
      >
        <Group h="100%" px="md" justify="space-between">
          <Group>
            <Burger
              opened={mobileOpened}
              onClick={toggleMobile}
              hiddenFrom="md"
              size="sm"
              color="#fff"
            />
            <Burger
              opened={desktopOpened}
              onClick={toggleDesktop}
              visibleFrom="md"
              size="sm"
              color="#fff"
            />
            <div className="text-lg font-semibold">
              {getPageTitle()}
            </div>
          </Group>

          <Group>
            <button
              style={{
                padding: '8px',
                borderRadius: '50%',
                background: 'transparent',
              }}
            >
              <IconSearch size={20} color="#fff" />
            </button>

            <button
              style={{
                padding: '8px',
                borderRadius: '50%',
                background: 'transparent',
                position: 'relative',
              }}
            >
              <IconBell size={20} color="#fff" />
              <span
                style={{
                  position: 'absolute',
                  top: 4,
                  right: 4,
                  width: 8,
                  height: 8,
                  background: 'var(--error-color)',
                  borderRadius: '50%',
                }}
              />
            </button>
          </Group>
        </Group>
      </AppShell.Header>

      {/* Navbar */}
      <AppShell.Navbar
        style={{
          background: 'var(--secondary-color)',
          color: '#fff',
          borderRight: 'none',
        }}
      >
        <AdminNavbar closeDrawer={toggleMobile} />
      </AppShell.Navbar>

      {/* Main Content */}
      <AppShell.Main
        style={{
          background: '#f8fafc',
          minHeight: '100vh',
          fontFamily: 'var(--font-family)',
        }}
      >
        <Container size="xl" py="md">
          <Outlet />
        </Container>
      </AppShell.Main>
    </AppShell>
  );
};